import React from 'react';
import { Modal, Input, Form, Select, Icon,DatePicker} from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_NUMBER, FORMAT_3DECIMALS, } from "../../../common/types/regularExpresionType";
const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
class ViewModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
          this.props.form.setFieldsValue({ [property]: "0.000" });
        else
          this.props.form.setFieldsValue({
            [property]: parseFloat(value).toFixed(3),
          });
      };


    handleCancel = () => {
        this.props.onClose();
        //this.props.form.resetFields();
    }




    render() {
        
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Ver Apertura de Caja"}
                visible={this.props.visible}
                cancelText={"Cerrar"}
                okText={"Ok"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel} 
                style={{ top: 30 }}
            >
                <Form>


                    <div className="row">

                        <div className="col-md-6">
                            <Form.Item label="Nro Planilla">
                        

                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                            readOnly
                                            className="text-right second-input"
                                            placeholder="Serie"
                                            autoComplete="off"
                                        
                                        />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                             
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("FechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.FechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("TipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.TipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                            readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "TipoCambio",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                    </div>
                    


                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaEstablecimiento.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                         
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaCaja.map((item) => (
                                                       item.idTipoCaja == 1 ? <Option key={item.id} value={item.id}>
                                                       {item.nombre}
                                                   </Option> : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">
                        <Form.Item label="Responsable de Manejo de Caja">
                                {getFieldDecorator('responsable', {
                                    initialValue: this.props.formValues.responsable,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Search
                                    readOnly
                                    placeholder="Búsqueda por Documento"
                                    autoComplete="off"
                                    maxLength={20}
                                    //loading={this.props.formValues.searchLoading}
                                    //onSearch={this.handleFilter}
                                />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha cierre (Referencial)">
                  
                                        {getFieldDecorator("fechaReferencial", {
                                            initialValue: moment(
                                                this.props.formValues.fechaReferencial,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                format="DD/MM/YYYY"
                                              
                                            />
                                        )}
                              
                            </Form.Item>
                        </div>
                    </div>

           
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(ViewModal)